import type { Conversation } from '../services/communications.service';
import { createContext, useContext } from 'react';
export interface CommunicationNavigation {
  pro: string | null;
  openQueue: (pro: string) => void;
}
export const CommunicationNavigationContext = createContext<CommunicationNavigation>({ pro: null, openQueue: () => {} });
export const useCommunicationNavigation = () => useContext(CommunicationNavigationContext);

export const ConversationFeedContext = createContext<{ identity?: string; rows: Conversation[]; loading: boolean; error: string }>({ rows: [], loading: false, error: '' });
export const useConversations = () => useContext(ConversationFeedContext);
